import { Api } from '@axiom/ui';
import type { UserSetting } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class UserSettingApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  async updateUserSetting(body: Partial<UserSetting>) {
    return super.write<{ data: UserSetting }>({
      endpoint: `/user/settings/${body.name}`,
      method: 'PUT',
      body,
    });
  }
}

export const UserSettingApi = new UserSettingApiClass();
